import * as CA from '../actions/captchaActions'
import { RSAA } from 'redux-api-middleware';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { ajax } = ssCommonUtils;

export const updateCaptchaField = v => ({ type: CA.CAPTCHA_INPUT_FIELD_UPDATE, payload: v.target.value });

export const loadCaptcha = () => {
    return ajax({
    method: 'GET',
    endpoint: '/session/captcha',
    headers: { 'Content-Type': 'application/json' },
    types: [
        CA.CAPTCHA_PENDING,
        {
            type: CA.CAPTCHA_SUCCESS,
            payload: (action, status, response) => ({
                type: action,
                payload: response
            })
        },
        CA.CAPTCHA_FAILURE
    ]
})
};

export const checkCaptcha = captcha => {
    return ({ [RSAA]: {
     method: 'GET',
     endpoint: `/session/captcha/${captcha}`,
     headers: { 'Content-Type': 'application/json' },
     types: [
         CA.CAPTCHA_VALIDATION_PENDING,
         CA.CAPTCHA_VALIDATION_SUCCESS,
         CA.CAPTCHA_VALIDATION_FAILURE
     ]
 }})
 };

export const validateCaptcha = captcha => {
   return ({ [RSAA]: {
    method: 'POST',
    endpoint: `/session/captcha/${captcha}`,
    headers: { 'Content-Type': 'application/json' },
    types: [
        CA.CAPTCHA_VALIDATION_PENDING,
        CA.CAPTCHA_VALIDATION_SUCCESS,
        CA.CAPTCHA_VALIDATION_FAILURE
    ]
}})
};
 
export const resetCaptchaValidation = () => ({ type: CA.CAPTCHA_VALIDATION_RESET });
export const resetCaptchaField = () => ({ type: CA.CAPTCHA_FIELD_RESET });
export const setValidated = (value) => ({ type: CA.CAPTCHA_SET_VALIDATED, value:value });
